import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { Observable } from 'rxjs';
import { AccountService } from '../services/account.service';

@Injectable( {
    providedIn: 'root'
} )
export class SysAdminGuard implements CanActivate {
    constructor( private accountService: AccountService,     
        private router: Router ) {}

    canActivate(): Observable<boolean> | Promise<boolean> | boolean {
        if ( this.accountService.getAccount().email.trim() != "" ) {
            if (this.accountService.getAccount().sysAdmin)
                return true;
            else
                this.router.navigate( ['/'] );
        } else {
            this.router.navigate( ['/'] );
        }
        return false;
    }
}

